import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgReloadIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m5.414 4 .354 3.102 3.182.344"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6.5A8.14 8.14 0 0 1 11.89 4C16.369 4 20 7.582 20 12s-3.631 8-8.11 8A8.14 8.14 0 0 1 6 17.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgReloadIcon);
const Memo = memo(ForwardRef);
export default Memo;
